import { useState, useEffect } from "react";
import { fetchCompanyInfo, getCompanyInfoSync } from "@/services/api";

// Hardcoded fallbacks for contact-info fields so the footer/contact page
// always shows something sensible even before the API responds.
// Social-link fields are intentionally empty — they only show when the
// admin has explicitly filled them in the DB.
const FALLBACK = {
  phone:         "+90 530 890 0502",
  email:         "oberyapi@gmail.com",
  address:       "Nakipoğlu, Hacı Hasanbaşı Cd. 80 A, 42030 Karatay/Konya",
  working_hours: "Pzt - Cmt: 09:00 - 18:00",
  maps_url:      "https://maps.app.goo.gl/xojfZtHRjJ1Ew7N1A",
  // Social links — empty by default; shown only when API returns a real URL
  instagram:     "",
  facebook:      "",
  youtube:       "",
  linkedin:      "",
  logo_url:      "",
  favicon_url:   "",
};

/**
 * Merge raw API response onto fallback defaults.
 * Rules:
 *   - API returns a non-empty string  → use it (overrides fallback)
 *   - API returns ""                  → use "" (admin explicitly cleared the field)
 *   - API returns null / undefined    → keep the fallback value
 * This ensures contact-info fallbacks survive DB rows where some columns are NULL,
 * while social-link fields only show when the admin has set a real URL.
 */
function merge(raw) {
  if (!raw) return { ...FALLBACK };
  const out = { ...FALLBACK };
  for (const [key, val] of Object.entries(raw)) {
    if (val !== null && val !== undefined) {
      out[key] = val; // includes "" — respects admin clearing a field
    }
    // null/undefined → leave the fallback value untouched
  }
  return out;
}

export function useCompanyInfo() {
  // Initialise synchronously from cache (warm after first page load → no flash)
  const [info, setInfo] = useState(() => merge(getCompanyInfoSync()));

  useEffect(() => {
    let cancelled = false;
    fetchCompanyInfo()
      .then((data) => { if (!cancelled) setInfo(merge(data)); })
      .catch(() => {}); // network error → keep fallback already in state
    return () => { cancelled = true; };
  }, []);

  return info;
}
